import styled from 'styled-components';

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: { colors } }) => colors.onSurface};
`;

export const SectionNote = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;
